import { Checkbox, Divider, FormControlLabel, Grid, Stack, TextField, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { formatDate } from '../../../../utils/dateHelpers';

import GuardianOrCaregiverInput from '../../Shared/GuardianOrCaregiverInput';
import Initials from '../../Shared/Initials';
import Signature from '../../Shared/Signature';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../store/store';
import { RootState } from '../../../../reducers';
import { setDigitalSignatureForm } from '../../../../store/consentSlice.slice';
import { ConsentSignatureTypeEnum } from '../../../../Enum/ConsentSignatureTypeEnum';
import SignatureTypeTabs from '../../Shared/SignatureTypeTabs';

const DocumentAcknowledgementSpanish = () => {
    const { activeStep, digitalSignatureForm } = useSelector((state: RootState) => state.consentSlice);
    const dispatch = useAppDispatch();
    const [openMemberRights, setOpenMemberRights] = useState(false);
    const [openPrivacyPractices, setOpenPrivacyPractices] = useState(false);
    const [openCCGProcedure, setOpenCCGProcedure] = useState(false);
    const [openProtectedInfo, setOpenProtectedInfo] = useState(false);
    const [openConsentTreatment, setOpenConsentTreatment] = useState(false);
    const [openMemberFees, setOpenMemberFees] = useState(false);
    const [openMemberSignatureDocumentAcknowledgement, setOpenMemberSignatureDocumentAcknowledgement] = useState(false);
    const [openGuardianOrCareGiverDocumentAcknowledge, setOpenGuardianOrCareGiverDocumentAcknowledge] = useState(false);
    const [openGuardianOrCareGiverWitnessDocumentAcknowledge, setOpenGuardianOrCareGiverWitnessDocumentAcknowledge] = useState(false);
    const [openVerbalConsent, setOpenVerbalConsent] = useState(false);

    useEffect(() => {
        const element = document.getElementById('top');
        element.scrollIntoView({ behavior: 'smooth' });
    }, [activeStep]);

    return (
        <>
            <div id="top" className="initials-div"></div>
            <Typography variant="h5" p={2} fontWeight={'bold'} mt={5}>
                Documento de Aceptación
            </Typography>

            <Typography variant="h6" my={5}>
                Yo acepto que he recibido una copia de:
            </Typography>
            <Grid container spacing={2} rowGap={1} p={2} textAlign={'left'} alignItems={'center'}>
                {/* Member's Rights */}

                <Grid size={12} sx={{ p: '0!important' }}>
                    <div className="initials-div" id="member-rights"></div>
                </Grid>
                <Grid size={6}>
                    <Typography variant="body1" fontWeight={'bold'}>
                        Derechos del miembro
                    </Typography>
                </Grid>

                <Grid size={6}>
                    <Initials
                        isSpanish={true}
                        isOpen={openMemberRights}
                        setIsOpen={setOpenMemberRights}
                        initials={digitalSignatureForm.MemberRights}
                        setInitials={(initials: string) =>
                            dispatch(
                                setDigitalSignatureForm({
                                    ...digitalSignatureForm,
                                    MemberRights: initials,
                                })
                            )
                        }
                    />
                </Grid>
                {/* Privacy Practices */}
                <Grid size={12} sx={{ p: '0!important' }}>
                    <div className="initials-div" id="privacy-practices"></div>
                </Grid>
                <Grid size={6}>
                    <Typography variant="body1" fontWeight={'bold'}>
                        Notificación de prácticas de privacidad
                    </Typography>
                </Grid>
                <Grid size={6}>
                    <Initials
                        isSpanish={true}
                        isOpen={openPrivacyPractices}
                        setIsOpen={setOpenPrivacyPractices}
                        initials={digitalSignatureForm.PrivacyPractices}
                        setInitials={(initials: string) =>
                            dispatch(
                                setDigitalSignatureForm({
                                    ...digitalSignatureForm,
                                    PrivacyPractices: initials,
                                })
                            )
                        }
                    />
                </Grid>
                {/* CCG Procedure */}
                <Grid size={12} sx={{ p: '0!important' }}>
                    <div className="initials-div" id="ccg-procedure"></div>
                </Grid>
                <Grid size={6}>
                    <Typography variant="body1" fontWeight={'bold'}>
                        Procedimiento de CHP de cumplidos, quejas y agravios
                    </Typography>
                </Grid>
                <Grid size={6}>
                    <Initials
                        isSpanish={true}
                        isOpen={openCCGProcedure}
                        setIsOpen={setOpenCCGProcedure}
                        initials={digitalSignatureForm.CCGProcedure}
                        setInitials={(initials: string) =>
                            dispatch(
                                setDigitalSignatureForm({
                                    ...digitalSignatureForm,
                                    CCGProcedure: initials,
                                })
                            )
                        }
                    />
                </Grid>
                {/* Protected Info */}
                <Grid size={12} sx={{ p: '0!important' }}>
                    <div className="initials-div" id="protected-info"></div>
                </Grid>
                <Grid size={6}>
                    <Typography variant="body1" fontWeight={'bold'}>
                        Autorización para liberación de información protegida
                    </Typography>
                </Grid>
                <Grid size={6}>
                    <Initials
                        isSpanish={true}
                        isOpen={openProtectedInfo}
                        setIsOpen={setOpenProtectedInfo}
                        initials={digitalSignatureForm.ProtectedInfo}
                        setInitials={(initials: string) =>
                            dispatch(
                                setDigitalSignatureForm({
                                    ...digitalSignatureForm,
                                    ProtectedInfo: initials,
                                })
                            )
                        }
                    />
                </Grid>
                {/* Consent Treatment */}
                <Grid size={12} sx={{ p: '0!important' }}>
                    <div className="initials-div" id="consent-treatment"></div>
                </Grid>
                <Grid size={6}>
                    <Typography variant="body1" fontWeight={'bold'}>
                        Consentimiento para el tratamiento
                    </Typography>
                </Grid>
                <Grid size={6}>
                    <Initials
                        isSpanish={true}
                        isOpen={openConsentTreatment}
                        setIsOpen={setOpenConsentTreatment}
                        initials={digitalSignatureForm.ConsentTreatment}
                        setInitials={(initials: string) =>
                            dispatch(
                                setDigitalSignatureForm({
                                    ...digitalSignatureForm,
                                    ConsentTreatment: initials,
                                })
                            )
                        }
                    />
                </Grid>
                {/* Member Fees */}
                <Grid size={12} sx={{ p: '0!important' }}>
                    <div className="initials-div" id="member-fees"></div>
                </Grid>
                <Grid size={6}>
                    <Typography variant="body1" fontWeight={'bold'}>
                        Política de CHP para cuotas/Co-Pagos de CHP
                    </Typography>
                </Grid>
                <div id="document-acknowledge-signature"></div>
                <Grid size={6}>
                    <Initials
                        isSpanish={true}
                        isOpen={openMemberFees}
                        setIsOpen={setOpenMemberFees}
                        initials={digitalSignatureForm.MemberFees}
                        setInitials={(initials: string) =>
                            dispatch(
                                setDigitalSignatureForm({
                                    ...digitalSignatureForm,
                                    MemberFees: initials,
                                })
                            )
                        }
                    />
                </Grid>
            </Grid>

            <SignatureTypeTabs isSpanish={true} />
            <Divider />
            <Grid container spacing={2} p={2}>
                {digitalSignatureForm.SignatureType === ConsentSignatureTypeEnum.Patient && (
                    <>
                        <Grid size={6}>
                            <TextField
                                id="member-name"
                                error={digitalSignatureForm.MemberName.length === 0}
                                variant="standard"
                                value={digitalSignatureForm.MemberName}
                                label={`Nombre del paciente`}
                                fullWidth
                                onChange={(e) => {
                                    dispatch(
                                        setDigitalSignatureForm({
                                            ...digitalSignatureForm,
                                            MemberName: e.target.value,
                                        })
                                    );
                                }}
                            />
                        </Grid>
                        <Grid size={6}>
                            <TextField variant="standard" value={`${formatDate(new Date(), 'MM-dd-yyyy')}`} label={`Fecha`} fullWidth />
                        </Grid>
                        <Grid size={12}>
                            <Signature
                                isSpanish={true}
                                buttonLabel={'Signature'}
                                isOpen={openMemberSignatureDocumentAcknowledgement}
                                setIsOpen={setOpenMemberSignatureDocumentAcknowledgement}
                                signature={digitalSignatureForm.MemberSignatureThree}
                                setSignature={(signature: string) =>
                                    dispatch(
                                        setDigitalSignatureForm({
                                            ...digitalSignatureForm,
                                            MemberSignatureThree: signature,
                                        })
                                    )
                                }
                            />
                        </Grid>
                    </>
                )}
                <Grid size={12} textAlign={'left'}>
                    {/* Guardian or Caregiver */}
                    {digitalSignatureForm.SignatureType === ConsentSignatureTypeEnum.GuardianOrCaregiver && (
                        <GuardianOrCaregiverInput
                            isSpanish={true}
                            openGuardianOrCaregiver={openGuardianOrCareGiverDocumentAcknowledge}
                            setOpenGuardianOrCaregiver={setOpenGuardianOrCareGiverDocumentAcknowledge}
                            guardianOrCareGiver={digitalSignatureForm.GuardianOrCaregiverSignatureDocumentAcknowledge}
                            setGuardianOrCareGiver={(signature: string) =>
                                dispatch(
                                    setDigitalSignatureForm({
                                        ...digitalSignatureForm,
                                        GuardianOrCaregiverSignatureDocumentAcknowledge: signature,
                                    })
                                )
                            }
                            openGuardianOrCareGiverWitness={openGuardianOrCareGiverWitnessDocumentAcknowledge}
                            setOpenGuardianOrCareGiverWitness={setOpenGuardianOrCareGiverWitnessDocumentAcknowledge}
                            guardianOrCareGiverWitness={digitalSignatureForm.WitnessDocumentAcknowledge}
                            setGuardianOrCareGiverWitness={(signature: string) =>
                                dispatch(
                                    setDigitalSignatureForm({
                                        ...digitalSignatureForm,
                                        WitnessDocumentAcknowledge: signature,
                                    })
                                )
                            }
                        />
                    )}
                </Grid>
                <Grid size={12}>
                    {digitalSignatureForm.SignatureType === ConsentSignatureTypeEnum.Verbal && (
                        <>
                            {/* Verbal Consent */}
                            <Stack>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={digitalSignatureForm.VerbalConsent}
                                            onChange={() =>
                                                dispatch(
                                                    setDigitalSignatureForm({
                                                        ...digitalSignatureForm,
                                                        VerbalConsent: !digitalSignatureForm.VerbalConsent,
                                                    })
                                                )
                                            }
                                        />
                                    }
                                    label={
                                        <Typography>
                                            El consentimiento verbal es necesario si el miembro o representante legal no puede firmar físicamente en este
                                            momento y sin embargo el consentimiento para el cuidado ha sido explícitamente acordado.
                                            <b> El consentimiento verbal debe ser presenciado por dos personas por teléfono o en persona.</b>
                                        </Typography>
                                    }
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={digitalSignatureForm.ReviewedThree}
                                            onChange={() =>
                                                dispatch(
                                                    setDigitalSignatureForm({
                                                        ...digitalSignatureForm,
                                                        ReviewedThree: !digitalSignatureForm.ReviewedThree,
                                                    })
                                                )
                                            }
                                        />
                                    }
                                    label={
                                        <Typography>
                                            <b> El proveedor ha revisado esta página del formulario de consentimiento con el miembro</b>
                                        </Typography>
                                    }
                                />
                                <Grid container spacing={2}>
                                    <Grid size={6}>
                                        <TextField
                                            variant="outlined"
                                            required
                                            fullWidth
                                            helperText="Firma Digital del Testigo"
                                            sx={{ mt: 5 }}
                                            label={'Testigo Uno'}
                                            value={digitalSignatureForm.VerbalConsentWitnessOne}
                                            onChange={(e) =>
                                                dispatch(
                                                    setDigitalSignatureForm({
                                                        ...digitalSignatureForm,
                                                        VerbalConsentWitnessOne: e.target.value,
                                                    })
                                                )
                                            }
                                        />
                                    </Grid>
                                    <Grid size={6}>
                                        <TextField
                                            variant="outlined"
                                            required
                                            fullWidth
                                            helperText="Firma Digital del Testigo"
                                            sx={{ mt: 5 }}
                                            label={'Testigo Dos'}
                                            value={digitalSignatureForm.VerbalConsentWitnessTwo}
                                            onChange={(e) =>
                                                dispatch(
                                                    setDigitalSignatureForm({
                                                        ...digitalSignatureForm,
                                                        VerbalConsentWitnessTwo: e.target.value,
                                                    })
                                                )
                                            }
                                        />
                                    </Grid>
                                    <Grid size={12}>
                                        <Signature
                                            isSpanish={true}
                                            buttonLabel={'Firma del Testigo'}
                                            isOpen={openVerbalConsent}
                                            setIsOpen={setOpenVerbalConsent}
                                            signature={digitalSignatureForm.VerbalConsentSignature}
                                            setSignature={(signature: string) =>
                                                dispatch(
                                                    setDigitalSignatureForm({
                                                        ...digitalSignatureForm,
                                                        VerbalConsentSignature: signature,
                                                    })
                                                )
                                            }
                                        />
                                    </Grid>
                                </Grid>
                            </Stack>
                        </>
                    )}
                </Grid>
            </Grid>
        </>
    );
};

export default DocumentAcknowledgementSpanish;
